import { AlertTriangle } from 'lucide-react'

/**
 * hr2-v2 (E9, löst hr-v3 R11 ein): einheitlicher Modul-inaktiv-Hinweis der
 * HR-Arbeitsseiten — ersetzt die 3× inline duplizierten Blöcke.
 */
export function HrModuleInactiveNotice({ title }: { title?: string }) {
  return (
    <div className="p-6">
      {title && <h1 className="text-2xl font-bold mb-2">{title}</h1>}
      <div className="p-4 bg-amber-50 border border-amber-200 text-amber-800 rounded-lg max-w-xl flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
        <div>
          Diese Seite ist aktuell nicht aktiv. Die Aktivierung erfolgt durch den
          Superadmin (Einstellungen → HR-Modul) oder — falls erlaubt — über die HR-Einstellungen.
        </div>
      </div>
    </div>
  )
}
